import { Link, NavLink, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'

import logo from '../logo.png'
import SidebarTitlesMenu from './SidebarTitlesMenu'

import { FiHome } from 'react-icons/fi'
import { BiUser } from 'react-icons/bi'
import { MdOutlineCategory } from 'react-icons/md'
import { MdOutlineAdminPanelSettings } from 'react-icons/md'
import { VscDiffAdded } from 'react-icons/vsc'
import { MdOutlinePayments } from 'react-icons/md'
import { AiOutlineShopping } from 'react-icons/ai'
import { TbShoppingCartSearch } from "react-icons/tb"
import { FaRegChartBar } from 'react-icons/fa'
import { IoChevronDown } from 'react-icons/io5'
import { BiVideoPlus } from "react-icons/bi";
import { CgGames } from "react-icons/cg";

// import { FiSettings } from 'react-icons/fi'


const AdminSidebar = ({ buyer = false }) => {
     const location = useLocation()
     const [newPostOpen, setNewPostOpen] = useState(false)

     const isNewPostPage = location.pathname === '/newpost'
     const postType = new URLSearchParams(location.search).get('type')
     const isGamePostActive = isNewPostPage && postType !== 'video'
     const isVideoPostActive = isNewPostPage && postType === 'video'

     useEffect(() => {
          if (isNewPostPage) {
               setNewPostOpen(true)
          }
     }, [isNewPostPage])

     return (
          <>
               <nav className='navbarSide'>
                    <div className='logo'>
                         <img src={logo} alt='' />
                    </div>

                    <menu>

                         <NavLink to={''} end>
                              <FiHome />
                              <span>داشبورد</span>
                         </NavLink>

                         {buyer && <NavLink to={'/purchased'}>
                              <AiOutlineShopping />
                              <span>خرید های من</span>
                         </NavLink>}

                         <hr style={{ opacity: .1 }} />

                         <NavLink to={'/checkout'}>
                              <MdOutlinePayments />
                              <span>حسابداری</span>
                         </NavLink>

                         <NavLink to={'/orders'}>
                              <TbShoppingCartSearch />
                              <span>سفارشات</span>
                         </NavLink>

                         <NavLink to={'/reports'}>
                              <FaRegChartBar />
                              <span>گزارشات</span>
                         </NavLink>

                         <hr style={{ opacity: .1 }} />
                         <SidebarTitlesMenu />

                         <div className={`sidebarDropdown ${newPostOpen ? 'open' : ''} ${isNewPostPage ? 'active' : ''}`}>
                              <button
                                   type="button"
                                   className="sidebarDropdown__toggle"
                                   onClick={() => setNewPostOpen((prev) => !prev)}
                              >
                                   <VscDiffAdded />
                                   <span>افزودن عنوان جدید</span>
                                   <IoChevronDown className="sidebarDropdown__arrow" />
                              </button>

                              <div className="sidebarDropdown__menu">
                                   <Link
                                        to="/newpost"
                                        className={isGamePostActive ? 'isCurrentPage' : undefined}
                                        aria-current={isGamePostActive ? 'page' : undefined}
                                        onClick={() => setNewPostOpen(true)}
                                   >
                                        <CgGames />
                                        <span>افزودن بازی</span>
                                   </Link>

                                   <Link
                                        to="/newpost?type=video"
                                        className={isVideoPostActive ? 'isCurrentPage' : undefined}
                                        aria-current={isVideoPostActive ? 'page' : undefined}
                                        onClick={() => setNewPostOpen(true)}
                                   >
                                        <BiVideoPlus />
                                        <span>افزودن ویدئو</span>
                                   </Link>
                              </div>
                         </div>

                         <NavLink to={'/category'}>
                              <MdOutlineCategory />
                              <span>دسته بندی ها</span>
                         </NavLink>
                         <hr style={{ opacity: .1 }} />

                         <NavLink to={'/users'}>
                              <MdOutlineAdminPanelSettings />
                              <span>کاربران</span>
                         </NavLink>

                         {/* <NavLink to={'/settings'}>
                              <FiSettings />
                              <span>تنظیمات</span>
                         </NavLink> */}



                         <NavLink to={'/profile'}>
                              <BiUser />
                              <span>پروفایل</span>
                         </NavLink>
                    </menu>

                    <div className='versionApp'>نسخه: 2.5.0</div>
               </nav>
          </>
     )
}

export default AdminSidebar